import PropTypes from "prop-types";
import { Typography } from "@material-ui/core";

export default function SectionTitle({ number, title, classes }) {
  return (
    <div className={classes.sectionTitleRow}>
      <div className={classes.sectionBadge}>{number}</div>
      <Typography component="h2" className={classes.sectionTitleText}>
        {title}
      </Typography>
    </div>
  );
}

SectionTitle.propTypes = {
  number: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  title: PropTypes.string.isRequired,
  classes: PropTypes.object.isRequired,
};
